import { FilterValue } from "../Filters/FilterValue";
import { SortType } from "../SortType";

export interface UrgentSourcingProductFilters {
  page_no?: number;
  search_text?: string;
  added_by?: FilterValue[];
  limit?: number;
  sort_by?: string;
  sort_type?: SortType;
  product_created?: boolean;
}

export const ProductStatusFilter = [
  { value: "Yes", id: "true" },
  { value: "No", id: "false" },
];
